<template>
  <div class="m-cont">
    <div class="nav-sale">
      <div class="con-sal">
        <span>
          <a href="#" class="btn btn-outline-success btn-sm" @click="home">Home</a>
        </span>
        AI REPORT & ANALISI
      </div>
    </div>

    <div class="container-fluid mt-4">
      <div class="row">
        <!-- Sidebar: History -->
        <div class="col-md-3">
          <div class="card shadow-sm h-100">
            <div class="card-header bg-dark text-white">
              <h5 class="mb-0">Storico Report</h5>
            </div>
            <div class="list-group list-group-flush overflow-auto" style="max-height: 70vh;">
              <div 
                v-for="rep in reports" 
                :key="rep._id" 
                class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                :class="{ active: selectedReport && selectedReport._id === rep._id }"
                @click="selectReport(rep)"
              >
                <div class="text-truncate mr-2">
                  <small class="d-block text-muted">{{ formatDate(rep.created_at) }}</small>
                  {{ rep.domanda }}
                </div>
                <button class="btn btn-sm btn-outline-danger ml-2" @click.stop="confirmDelete(rep._id)" title="Elimina report">
                  <i class="fas fa-trash"></i>
                </button>
              </div>
              <div v-if="reports.length === 0" class="p-3 text-center text-muted">
                Nessun report salvato.
              </div>
            </div>
          </div>
        </div>

        <!-- Main Area: Chat & Result -->
        <div class="col-md-9">
          <div class="card shadow-sm h-100">
            <div class="card-body d-flex flex-column" style="min-height: 75vh;">
              <!-- Input Area -->
              <div class="input-group mb-4">
                <input 
                  type="text" 
                  class="form-control form-control-lg" 
                  v-model="query" 
                  placeholder="Chiedi all'IA (es. 'Andamento ristorante', 'Crea un menu basato sul magazzino')..."
                  @keyup.enter="sendQuery"
                  :disabled="loading"
                >
                <div class="input-group-append">
                  <button class="btn btn-primary" @click="sendQuery" :disabled="loading || !query">
                    <span v-if="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    Chiedi all'IA
                  </button>
                </div>
              </div>

              <!-- Content Display -->
              <div class="flex-grow-1 border rounded bg-light d-flex flex-column" style="height: 75vh; overflow: hidden;">
                <div class="flex-grow-1 overflow-auto p-3" id="report-container">
                  <div v-if="loading" class="text-center mt-5">
                    <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;"></div>
                    <p class="mt-3">L'intelligenza artificiale sta analizzando i dati...</p>
                  </div>
                  
                  <div v-else-if="selectedReport" v-html="renderedReport" class="ai-report-content mb-20"></div>
                  
                  <div v-else class="text-center text-muted mt-5">
                    <h4>Benvenuto nell'assistente AI</h4>
                    <p>Inserisci una domanda sopra per generare un report dettagliato basato sui dati del tuo ristorante.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { marked } from 'marked';
import axios from 'axios';
import { store } from '../store/store.js';

export default {
  data() {
    return {
      store: store,
      query: '',
      loading: false,
      reports: [],
      selectedReport: null
    };
  },
  computed: {
    renderedReport() {
      if (!this.selectedReport || !this.selectedReport.risposta) return '';
      // Se la risposta sembra già HTML, ritorna com'è, altrimenti converti da Markdown
      const content = this.selectedReport.risposta;
      if (content.trim().startsWith('<')) {
        return content;
      }
      return marked(content);
    }
  },
  mounted() {
    this.fetchReports();
  },
  methods: {
    home() {
      this.$router.push({ name: "Gestionale" });
    },
    fetchReports() {
      axios.get(this.store.path + 'report-ai/reportsAI', {
        headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
      }).then((response) => {
        this.reports = response.data.messaggio;
      }).catch(err => {
        console.error("Error fetching reports:", err);
      });
    },
    sendQuery() {
      if (!this.query || this.loading) return;
      this.loading = true;
      this.selectedReport = null;

      axios.post(this.store.path + 'report-ai/queryAI', {
        domanda: this.query
      }, {
        headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` },
        timeout: 300000 // 5 minuti di timeout per attendere la risposta dell'IA
      }).then((response) => {
        this.query = '';
        this.fetchReports();
        this.selectedReport = response.data.report;
      }).catch(err => {
        alert("Errore nella comunicazione con l'IA: " + err.message);
      }).finally(() => {
        this.loading = false;
      });
    },
    selectReport(rep) {
      this.selectedReport = rep;
    },
    confirmDelete(id) {
      if (confirm("Sei sicuro di voler eliminare questo report dallo storico?")) {
        axios.delete(this.store.path + `report-ai/reportAI/${id}`, {
          headers: { authorization: `Bearer ${JSON.parse(localStorage.token)}` }
        }).then(() => {
          if (this.selectedReport && this.selectedReport._id === id) {
            this.selectedReport = null;
          }
          this.fetchReports();
        });
      }
    },
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    }
  }
};
</script>

<style scoped>
.ai-report-content {
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
  line-height: 1.6;
}

.ai-report-content :deep(table) {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
  border-collapse: collapse;
}

.ai-report-content :deep(th),
.ai-report-content :deep(td) {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #dee2e6;
}

.ai-report-content :deep(thead th) {
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  background-color: #f8f9fa;
}

.ai-report-content :deep(.card) {
  background: white;
  border: 1px solid rgba(0,0,0,.125);
  border-radius: 0.5rem;
  margin-bottom: 1.5rem;
}

.ai-report-content :deep(h1), .ai-report-content :deep(h2), .ai-report-content :deep(h3) {
  color: #2c3e50;
  margin-top: 1.5rem;
  margin-bottom: 1rem;
}

.ai-report-content :deep(.progress-bar) {
  transition: width .6s ease;
}

.m-cont {
  background-color: #f4f7f6;
  min-height: 100vh;
}

.nav-sale {
  color: white;
  background-color: #2c3e50;
  padding: 15px;
  font-weight: bold;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
}

.card {
  margin-bottom: 20px;
}

#report-container {
  background: white !important;
  box-shadow: inset 0 1px 2px rgba(0,0,0,0.075);
  padding-bottom: 50px;
}

.list-group {
    max-height: 50vh;
    overflow-y: auto;
}

@media (max-width: 768px) {
    .col-md-3, .col-md-9 {
        width: 100%;
        margin-bottom: 20px;
    }
}
</style>
